'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _ExclamationCircle = require('./ExclamationCircle');

var _ExclamationCircle2 = _interopRequireDefault(_ExclamationCircle);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _splitProps2 = require('./utils/splitProps');

var _splitProps3 = _interopRequireDefault(_splitProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale,
    controlStateStyles = _theme2.default.controlStateStyles;


var styles = (0, _glamor.css)({
  backgroundColor: controlStateStyles.default.backgroundColor,
  color: controlStateStyles.default.color,
  border: controlStateStyles.default.border,
  transition: controlStateStyles.default.transition,
  '&:focus': {
    border: controlStateStyles.focus.border,
    boxShadow: controlStateStyles.focus.boxShadow
  }
});

function useControlSizes(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ['size']);

  var sizes = _theme2.default.controlSizes[size];

  return _extends({
    minHeight: sizes.minHeight,
    minWidth: sizes.minWidth,
    textStyle: sizes.textStyle,
    paddingX: size === 'small' ? minorScale(3) : majorScale(2)
  }, props);
}

var Input = function Input(_ref2) {
  var warning = _ref2.warning,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ['warning', 'className']);

  // Tries to treat this component as a single box
  var _splitProps = (0, _splitProps3.default)(useControlSizes(props), /margin|width|height|display|flex|alignItems|justifyContent|flexDirection|flexGrow|flexShrink/gi),
      matchedProps = _splitProps.matchedProps,
      unmatchedProps = _splitProps.unmatchedProps;

  return _react2.default.createElement(
    _Box2.default,
    _extends({ position: 'relative', display: 'flex' }, matchedProps),
    warning ? _react2.default.createElement(_ExclamationCircle2.default, { position: 'absolute', top: '50%', marginLeft: '-5px', marginTop: '-6px' }) : null,
    _react2.default.createElement(_Box2.default, _extends({ is: 'input', className: (0, _classnames2.default)('' + styles, className), flex: '1' }, unmatchedProps))
  );
};

Input.propTypes = {
  warning: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(Object.keys(_theme2.default.controlSizes))
};

Input.defaultProps = {
  rounded: true,
  size: 'default'
};

Input.displayName = 'Input';

exports.default = Input;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Input.js
// module id = 1124
// module chunks = 0